<h3>{{ getDialogTitle() | translate }}</h3>
<p class="alert alert-warning">{{ getDialogBody() | translate }}</p>
<div class="buttons">
    <button mat-flat-button color="warn" class="btn" type="button" (click)="dialogRef.close()">
        <span class="btn-text">{{ 'general.actions.CANCEL' | translate }}</span>
    </button>
    <button mat-flat-button color="primary" class="btn" type="button" (click)="editDisabled()">
        <span class="btn-text">{{ 'general.actions.CONFIRM' | translate }}</span>
    </button>
</div>